// Attribution: "PhET Interactive Simulations, University of Colorado Boulder, https://phet.colorado.edu";
const virtualManipulatives = [
    { 
        id: 1, 
        name: 'Arithmetic (Multiply, Factor, Divide)', 
        embedLink: 'https://phet.colorado.edu/sims/html/arithmetic/latest/arithmetic_en.html',
        thumbnail: 'https://phet.colorado.edu/sims/html/arithmetic/latest/arithmetic-420.png',
        tags: "Multiplication, Division, Factoring, Basic Arithmetic"
    },
    { 
        id: 2, 
        name: 'Make a Ten (Addition)', 
        embedLink: 'https://phet.colorado.edu/sims/html/make-a-ten/latest/make-a-ten_en.html',
        thumbnail: 'https://phet.colorado.edu/sims/html/make-a-ten/latest/make-a-ten-420.png',
        tags: "Addition, Mental Math, Number Sense" 
        
    },
    { 
        id: 3, 
        name: 'Build a Fraction', 
        embedLink:'https://phet.colorado.edu/sims/html/build-a-fraction/latest/build-a-fraction_en.html',
        thumbnail: 'https://phet.colorado.edu/sims/html/build-a-fraction/latest/build-a-fraction-420.png',
        tags: "Fractions, Numerator, Denominator, Parts of a Whole"
    },
    { 
        id: 4, 
        name: 'Number Compare', 
        embedLink:'https://phet.colorado.edu/sims/html/number-compare/latest/number-compare_en.html',
        thumbnail: 'https://phet.colorado.edu/sims/html/number-compare/latest/number-compare-420.png',
        tags: "Number Line, Number Comparison, Greater or Smaller" 
    },
    { 
        id: 5, 
        name: 'Expression Exchange (Combining Coins)', 
        embedLink:'https://phet.colorado.edu/sims/html/expression-exchange/latest/expression-exchange_en.html',
        thumbnail: 'https://phet.colorado.edu/sims/html/expression-exchange/latest/expression-exchange-420.png',
        tags: "Algebra, Expressions, Simplification, Equation Balancing" 
    },
    { 
        id: 6, 
        name: 'Fractions: Intro', 
        embedLink:'https://phet.colorado.edu/sims/html/fractions-intro/latest/fractions-intro_en.html',
        thumbnail: 'https://phet.colorado.edu/sims/html/fractions-intro/latest/fractions-intro-420.png',
        tags: "Fractions, Basic Fractions, Visual Models",
    },
    { 
        id: 7, 
        name: 'Fractions: Mixed Numbers', 
        embedLink:'https://phet.colorado.edu/sims/html/fractions-mixed-numbers/latest/fractions-mixed-numbers_en.html',
        thumbnail: 'https://phet.colorado.edu/sims/html/fractions-mixed-numbers/latest/fractions-mixed-numbers-420.png',
        tags: "Mixed Numbers, Improper Fractions, Fraction Conversion" 
    },
];

/* 
    { 
        id: x, 
        name: '', 
        embedLink:'',
        thumbnail: '', 
    },
*/
export default virtualManipulatives;
